import React from 'react';
import { CircleGauge } from 'lucide-react';
import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability, getPortfolioRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import NestedSidebarMenuItem, { NestedSidebarMenuLeafItem } from './NestedSidebarMenuItem';

const GlobalNaturePerformanceMenu = () => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const portfolioRoutesAvailability = useAppSelector(getPortfolioRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();

    if (!appRoutesAvailability.portfolio) {
        return null;
    }

    const subItems = (
        [
            portfolioRoutesAvailability.portfolioSummary && {
                title: 'Portfolio Summary',
                testId: 'portfolio-summary-menu-button',
                onClick: () => navigate.toPortfolioSummary(),
                isActive: pathname === '/portfolio' || pathname.startsWith('/portfolio?'),
            },
            portfolioRoutesAvailability.portfolioSiteExplorer && {
                title: 'Portfolio site explorer',
                testId: 'portfolio-site-explorer-menu-button',
                onClick: () => navigate.toPortfolioSiteExplorer(),
                isActive: pathname.includes('/portfolio/site-explorer'),
            },
            portfolioRoutesAvailability.speciesRiskIndicators && {
                title: 'Portfolio species risks',
                testId: 'portfolio-species-risks-menu-button',
                onClick: () => navigate.toPortfolioSpeciesRiskIndicators(),
                isActive: pathname.includes('/portfolio/species-risk-indicators'),
            },
            // The grid-backed preview set. All three read the grid now, and their
            // availability already requires an internal user who asked for the preview
            // with ?next=true — see getPortfolioRoutesAvailabilityForCustomer.
            portfolioRoutesAvailability.nextPortfolioSummary && {
                title: 'Portfolio summary (new)',
                testId: 'portfolio-next-summary-menu-button',
                onClick: () => navigate.toNextPortfolioSummary(),
                isActive: pathname.includes('/portfolio/next/summary'),
            },
            portfolioRoutesAvailability.nextSpeciesRiskIndicators && {
                title: 'Portfolio species risks (new)',
                testId: 'portfolio-next-species-risks-menu-button',
                onClick: () => navigate.toNextPortfolioSpeciesRiskIndicators(),
                isActive: pathname.includes('/portfolio/next/species-risk-indicators'),
            },
            portfolioRoutesAvailability.nextPortfolioSiteExplorer && {
                title: 'Portfolio site explorer (new)',
                testId: 'portfolio-next-site-explorer-menu-button',
                onClick: () => navigate.toNextPortfolioSiteExplorer(),
                isActive: pathname.includes('/portfolio/next/site-explorer'),
            },
            portfolioRoutesAvailability.portfolioFiles && {
                title: 'Portfolio files',
                testId: 'portfolio-files-menu-button',
                onClick: () => navigate.toPortfolioFiles(),
                isActive: pathname.includes('/portfolio/portfolio-files'),
            },
        ] as (NestedSidebarMenuLeafItem | false)[]
    ).filter((item): item is NestedSidebarMenuLeafItem => Boolean(item));

    if (subItems.length === 0) {
        return null;
    }

    const isActive = subItems.some(item => item.isActive);

    return (
        <NestedSidebarMenuItem
            label='Global Nature Performance'
            testId='global-nature-performance-menu-group-button'
            icon={<CircleGauge />}
            isActive={isActive}
            defaultOpen={isActive}
            subItems={subItems}
        />
    );
};

export default GlobalNaturePerformanceMenu;
